export default "__VITE_PUBLIC_ASSET__7d198c81__"